// NPM Imports
import React, { Component } from "react";
import { Droppable } from "react-beautiful-dnd";

// Components Imports
import KanbanSwimlaneCard from "../KanbanSwimlaneCard";

class KanbanSwimlane extends Component {
  state = {};

  render() {
    const { status, docs } = this.props;
    const { name, heading, color } = status;
    return (
      <div
        className="kanbanswimlane-column"
        data-test={`kanbanswimlane-column-${name}`}>
        <div
          className={`kanbanswimlane-title-wrap ${name}`}
          data-test={`kanbanswimlane-title-wrap-${name}`}
          style={{ borderColor: color }}>
          <div
            className="kanbanswimlane-title"
            data-test={`kanbanswimlane-title-${name}`}>
            {name}
          </div>
          <div
            className="kanbanswimlane-subtitle"
            data-test={`kanbanswimlane-subtitle-${name}`}>
            {heading}
          </div>

          <div className="kanbanswimlane-doc-count">
            <span data-test={`kanbanswimlane-doc-count-${name}`}>
              {docs && docs.length}
            </span>
          </div>
        </div>

        <Droppable droppableId={name}>
          {provided => (
            <div
              className="kanbanswimlane-documentcard-wrapper"
              data-test={`kanbanswimlane-documentcard-wrapper-${name}`}
              ref={provided.innerRef}>
              {docs.map((doc, index) => (
                <KanbanSwimlaneCard doc={doc} index={index} />
              ))}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

export default KanbanSwimlane;



// WEBPACK FOOTER //
// ./src/components/Kanban/KanbanSwimlane/index.js